(function () {
  'use strict';

  let cachedCardVariantId = '';

  // ============================================================
  //  ギフトタグ制御
  //  ・カートアイテム行に data-message-card-item 属性を付与（CSS制御用）
  //  ・メイン商品がゼロになったらギフトタグを自動削除
  // ============================================================
  const messageCardIds = window.__messageCardProductIds || [];

  function isMessageCardItem(item) {
    return messageCardIds.includes(item.product_id);
  }

  async function applyMessageCardControls() {
    const cartRoot = window.Shopify?.routes?.root ?? '/';

    let cart;
    try {
      const res = await fetch(`${cartRoot}cart.js`);
      cart = await res.json();
    } catch (e) {
      return;
    }

    const items = cart.items || [];
    const mainItems = items.filter(function (i) { return !isMessageCardItem(i); });
    const cardItems = items.filter(function (i) { return isMessageCardItem(i); });

    // メイン商品がゼロ → ギフトタグを全削除
    if (mainItems.length === 0 && cardItems.length > 0) {
      const updates = {};
      cardItems.forEach(function (i) { updates[i.key] = 0; });
      try {
        await fetch(`${cartRoot}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
        await refreshCartDrawer(cartRoot);

        // カートバブル（件数バッジ）を更新
        const updatedCart = await fetch(`${cartRoot}cart.js`).then(function (r) { return r.json(); });
        const bubbleCount = document.querySelector('[ref="cartBubbleCount"], .cart-bubble__text-count');
        const bubbleEl    = document.querySelector('[ref="cartBubble"], .cart-bubble');
        if (bubbleCount) {
          bubbleCount.textContent = updatedCart.item_count;
          if (updatedCart.item_count === 0) {
            bubbleCount.classList.add('hidden');
          }
        }
        if (bubbleEl && updatedCart.item_count === 0) {
          bubbleEl.classList.add('visually-hidden');
        }
        document.querySelectorAll(
          '[data-cart-count], .cart-count, .cart-item-count, .js-cart-count'
        ).forEach(function (el) { el.textContent = updatedCart.item_count; });

      } catch (e) {
        console.error('[CustomCart] ギフトタグ削除失敗:', e);
      }
      return;
    }

  }

  function observeCartDrawer() {
    const cartItemsEl = document.querySelector('cart-items-component');
    if (!cartItemsEl) return;
    new MutationObserver(function () {
      applyMessageCardControls();
    }).observe(cartItemsEl, { childList: true, subtree: true });
  }

  // ============================================================
  //  ドロワー更新処理
  // ============================================================
  async function refreshCartDrawer(cartRoot) {
    const drawerComponent = document.querySelector('cart-drawer-component');
    const cartItemsEl = document.querySelector('cart-items-component');
    const sectionId = cartItemsEl?.dataset?.sectionId;

    if (!sectionId) {
      console.error('[CustomCart] data-section-id が取得できませんでした');
      return;
    }

    try {
      const res = await fetch(`${cartRoot}?sections=${sectionId}`);
      const data = await res.json();

      if (!data[sectionId]) {
        console.error('[CustomCart] セクションHTMLが返ってきませんでした:', sectionId);
        return;
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(data[sectionId], 'text/html');
      const newCartItems = doc.querySelector('cart-items-component');

      if (newCartItems && cartItemsEl) {
        cartItemsEl.innerHTML = newCartItems.innerHTML;
      }

      drawerComponent
        ?.querySelector('dialog')
        ?.classList.remove('cart-drawer--empty');

    } catch (err) {
      console.error('[CustomCart] セクション取得失敗:', err);
    }

    openDrawer(drawerComponent);
  }

  function openDrawer(drawerComponent) {
    if (!drawerComponent) return;
    if (typeof drawerComponent.open === 'function') {
      drawerComponent.open();
      return;
    }
    const dialog = drawerComponent.querySelector('dialog');
    if (dialog && !dialog.open) {
      dialog.setAttribute('open', '');
    }
  }

  // ============================================================
  //  モーダル開閉ヘルパー
  //  モーダルDOMはクリック時に取得するため、初期化タイミング問題を回避
  //  モーダルは form / add-to-cart-component の子になっている場合があるため
  //  初回オープン時に <body> 直下に移動して position:fixed を確実に効かせる
  // ============================================================
  function ensureModalAtBody() {
    // ページ内に存在する全 #MessageCardModal のうち、最初の1つを body 直下に移動
    // （quick-add と buy-buttons で2つ出力される場合があるため、2つ目以降は削除）
    const modals = document.querySelectorAll('#MessageCardModal');
    if (modals.length === 0) return null;

    // 最初の1つを body 直下に移動（まだそこにない場合）
    const modal = modals[0];
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    // 重複している2つ目以降を削除
    for (let i = 1; i < modals.length; i++) {
      modals[i].remove();
    }

    return modal;
  }

  function openModal() {
    const modal = ensureModalAtBody();
    if (!modal) return;

    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';

    // 現在の選択状態をモーダルに反映（複数ある場合は最初のものから取得）
    const trigger = document.querySelector('.mc-trigger');
    const currentId = trigger?.dataset.selectedId || '';
    syncModalSelection(modal, currentId);

    const closeBtn = modal.querySelector('.mc-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    const modal = document.getElementById('MessageCardModal');
    if (!modal) return;

    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';

    const trigger = document.querySelector('.mc-trigger');
    if (trigger) {
      trigger.removeAttribute('aria-expanded');
      trigger.focus();
    }
  }

  function syncModalSelection(modal, selectedId) {
    modal.querySelectorAll('.mc-card').forEach(function (card) {
      card.setAttribute(
        'aria-selected',
        card.dataset.variantId === String(selectedId) ? 'true' : 'false'
      );
    });
  }

  function updateTrigger(variantId, label, price) {
    // ページ内に複数の #MessageCardTrigger が存在する場合（quick-add / buy-buttons）
    // すべて一括更新する
    document.querySelectorAll('.mc-trigger').forEach(function (trigger) {
      trigger.dataset.selectedId    = variantId;
      trigger.dataset.selectedLabel = label;
      trigger.dataset.selectedPrice = price;

      const labelEl = trigger.querySelector('.mc-trigger__label');
      const subEl   = trigger.querySelector('.mc-trigger__sub');
      if (labelEl) labelEl.textContent = label;
      if (subEl)   subEl.textContent   = price ? '+' + price : '追加しない';
    });
  }

  // ============================================================
  //  メイン処理
  // ============================================================
  function initCustomCart() {

    // ── クリックイベント（全て document に委譲） ──────────────
    document.addEventListener('click', async function (e) {

      // ① トリガーボタン → モーダルを開く
      if (e.target.closest('.mc-trigger')) {
        document.querySelectorAll('.mc-trigger').forEach(function (t) {
          t.setAttribute('aria-expanded', 'true');
        });
        openModal();
        return;
      }

      // ② モーダル内カード選択
      const card = e.target.closest('.mc-card');
      if (card) {
        const modal = document.getElementById('MessageCardModal');
        if (!modal) return;

        const variantId = card.dataset.variantId;
        const label     = card.dataset.label;
        const price     = card.dataset.price;
        const isNashi   = !price || label === 'なし';

        cachedCardVariantId = isNashi ? '' : variantId;

        syncModalSelection(modal, variantId);
        updateTrigger(variantId, label, price);

        setTimeout(closeModal, 180);
        return;
      }

      // ③ モーダル閉じるボタン
      if (e.target.closest('.mc-modal__close')) {
        closeModal();
        document.querySelectorAll('.mc-trigger').forEach(function (t) { t.removeAttribute('aria-expanded'); });
        return;
      }

      // ④ バックドロップクリック
      if (e.target.closest('.mc-modal__backdrop')) {
        closeModal();
        document.querySelectorAll('.mc-trigger').forEach(function (t) { t.removeAttribute('aria-expanded'); });
        return;
      }

      // ⑤ カートボタン
      const btn = e.target.closest(
        'add-to-cart-component button[type="submit"][name="add"]'
      );
      if (!btn || btn.disabled) return;
      if (!cachedCardVariantId) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const form = btn.closest('form') ||
        document.querySelector('form[action*="/cart/add"]');
      const variantId = form?.querySelector('[name="id"]')?.value;
      const quantity  = parseInt(form?.querySelector('[name="quantity"]')?.value || '1', 10);
      if (!variantId) return;

      const payload = {
        items: [
          { id: parseInt(variantId),              quantity: quantity },
          { id: parseInt(cachedCardVariantId),    quantity: 1 }
        ]
      };

      const atcComponent = btn.closest('add-to-cart-component');
      btn.setAttribute('disabled', 'true');

      try {
        const cartRoot = window.Shopify?.routes?.root ?? '/';

        const res = await fetch(`${cartRoot}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        });

        if (!res.ok) throw new Error('HTTP ' + res.status);
        await res.json();

        await refreshCartDrawer(cartRoot);

        fetch(`${cartRoot}cart.js`)
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            const bubbleCount = document.querySelector('[ref="cartBubbleCount"], .cart-bubble__text-count');
            const bubbleEl    = document.querySelector('[ref="cartBubble"], .cart-bubble');
            if (bubbleCount) {
              bubbleCount.textContent = cart.item_count;
              bubbleCount.classList.remove('hidden');
            }
            if (bubbleEl) bubbleEl.classList.remove('visually-hidden');
            document.querySelectorAll(
              '[data-cart-count], .cart-count, .cart-item-count, .js-cart-count'
            ).forEach(function (el) { el.textContent = cart.item_count; });
          })
          .catch(function () {});

        btn.removeAttribute('disabled');
        if (atcComponent) {
          atcComponent.classList.add('atc-added');
          setTimeout(function () { atcComponent.classList.remove('atc-added'); }, 2000);
        }

      } catch (err) {
        console.error('[CustomCart] カートイン失敗:', err);
        btn.removeAttribute('disabled');
        alert('カートへの追加に失敗しました。もう一度お試しください。');
      }

    }, true);

    // ── Escキーでモーダルを閉じる ────────────────────────────
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const modal = document.getElementById('MessageCardModal');
        if (modal && !modal.hidden) closeModal();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCustomCart();
      observeCartDrawer();
      applyMessageCardControls();
    });
  } else {
    initCustomCart();
    observeCartDrawer();
    applyMessageCardControls();
  }

})();
